export const routes = {
  home: '/',
  posts: '/posts',
  addPost: '/posts/new',
  singlePost: '/posts/:id',
};
